import { globals } from '@/src/globals'

export const caseStudyDetailSwitcher = (caseStudyDetails: HTMLElement): void => {
  const showGraphButton = caseStudyDetails.querySelector('.js-caseStudyDetails-showGraph') as unknown as HTMLElement
  const showTableButton = caseStudyDetails.querySelector('.js-caseStudyDetails-showTable') as unknown as HTMLElement
  const graphBlock = caseStudyDetails.querySelector('.js-caseStudyDetails-defaultGraphWrapper') as unknown as HTMLElement
  const tableBlock = caseStudyDetails.querySelector('.js-caseStudyDetails-individualTemplateWrapper') as unknown as HTMLElement

  if (!showGraphButton || !showTableButton || !graphBlock || !tableBlock) {
    console.log('Missing case study blocks')
    return
  }

  showGraphButton.addEventListener('click', () => {
    showGraphButton.classList.add('d-none')
    showTableButton.classList.remove('d-none')
    graphBlock.classList.remove('d-none')
    tableBlock.classList.add('d-none')
  })

  showTableButton.addEventListener('click', () => {
    showGraphButton.classList.remove('d-none')
    showTableButton.classList.add('d-none')
    graphBlock.classList.add('d-none')
    tableBlock.classList.remove('d-none')
  })
}
